import colors from "../base/colors";
import borders from "../base/borders";
import typography from "../base/typography";

import pxToRem from "../functions/pxToRem";

const { info, success, warning, error } = colors;
const { borderRadius } = borders;
const { size } = typography;

const alertContentInherit = {
  "& .MuiAlert-message": { color: "inherit" },
  "& .MuiAlertTitle-root": { color: "inherit", fontWeight: 600 },
  "& .MuiTypography-root": { color: "inherit" },
  "& .MuiIconButton-root": { color: "inherit" },
};

const filledVariant = (palette: { main: string; contrastText: string }) => ({
  backgroundColor: palette.main,
  color: palette.contrastText,
  "& .MuiAlert-icon": { color: palette.contrastText },
  ...alertContentInherit,
});

const standardVariant = (backgroundColor: string, textColor: string, iconColor: string) => ({
  backgroundColor,
  color: textColor,
  "& .MuiAlert-icon": { color: iconColor },
  ...alertContentInherit,
});

const outlinedVariant = (borderColor: string, textColor: string, iconColor: string) => ({
  borderColor,
  color: textColor,
  "& .MuiAlert-icon": { color: iconColor },
  ...alertContentInherit,
});

const alert = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.md,
      fontSize: size.sm,
      padding: `${pxToRem(10)} ${pxToRem(14)}`,
    },
    message: {
      fontSize: size.sm,
      lineHeight: 1.5,
      color: "inherit",
    },
    standardInfo: standardVariant("#E0F2FE", info.dark, info.main),
    standardSuccess: standardVariant("#D1FAE5", success.dark, success.main),
    standardWarning: standardVariant("#FEF3C7", warning.dark, warning.main),
    standardError: standardVariant("#FEE2E2", error.dark, error.main),
    outlinedInfo: outlinedVariant(info.main, info.dark, info.main),
    outlinedSuccess: outlinedVariant(success.main, success.dark, success.main),
    outlinedWarning: outlinedVariant(warning.main, warning.dark, warning.main),
    outlinedError: outlinedVariant(error.main, error.dark, error.main),
    filledInfo: filledVariant(info),
    filledSuccess: filledVariant(success),
    filledWarning: filledVariant(warning),
    filledError: filledVariant(error),
  },
};

export default alert;
